import * as clipboard from 'clipboard-polyfill';

import UIActions from '../../state/ui/UI.actions';

const copyToClipboard = text => {
    const blob = new Blob([text], { type: 'text/html' });
    const items = [
        new clipboard.ClipboardItem({
            'text/html': blob,
            'text/plain': text,
        }),
    ];
    return clipboard.write(items);
};

export const onCopy = code => dispatch => {
    copyToClipboard(code).then(
        () =>
            dispatch(UIActions.createSnack('codeBlock.copiedToClipboard', { variant: 'success' })),
        () => dispatch(UIActions.createSnack('codeBlock.unableToCopy', { variant: 'error' }))
    );
};
